export const selectCurrentUser = (state: RootState) => state.auth.user;
